import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-excavation-dialog',
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
      <h2>The excavation portfolio is about to begin</h2>
      <div class="cross-button">
        <button class="btn btn-icon" (click)="dialogRef.close()"><i class="material-icons">close</i></button>
</div>
  </div>
  <ul class="optionslist">
    <li>
      <strong>Full excavation</strong> – Invalidity check, Target scouting, 
      Infringement analysis and Damage analysis
    </li>
    <li>
      <strong>Invalidity check</strong> – Reference patents, Claim feature matrix, 
      Invalidity score
    </li>
    <li>
      <strong>Infringe fusion</strong> – Target scouting, Infringement analysis, 
      Damage analysis, Infringe score &amp; Damage value
    </li>
  </ul>
      <p class="bold-text" >How do you want to proceed?</p>
      <div class="button-container">
        <button class="btn btn-primary btn-disabled disabled" color="primary" >Full Excavation <span class="btn-lower-text" >Coming Soon</span> </button>
        <button class="btn btn-primary" color="primary" (click)="onSelect('pas')">Invalidity Check</button>
        <button class="btn btn-primary" color="primary" (click)="onSelect('skip')">Infringe Fusion</button>
      </div>
    </div>
  `,
  styles: [`
    .dialog-container {
      text-align: center;
      padding: 20px;
      color:black;
    }

    .dialog-header{
      display:flex;
      justify-content:space-between;
    }
    h2 {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 10px;
      line-height: 23px;
    }
    .body-text{
      font-size:12px;
    }
    .btn-icon{
      padding-block: 0;
    padding-right: 0;
    outline: none !important;
    box-shadow:none !important;
    }
    .bold-text{
      font-weight:700;
    }

    p {
      margin: 5px 0;
    }
    .button-container {
      display: flex;
      justify-content: center;
      gap: 10px;
      margin-top: 20px;
      
    margin-bottom: 20px;
    }
    button {
      font-size: 16px;
    }
    .optionslist {
      list-style-type: disc;  /* Use the default disc bullets */
      padding-left: 1.5rem;   /* Indent the bullets */
      text-align:start;

    }

    .optionslist li {
      margin-bottom: 0.5rem;  /* Spacing between items */
      line-height: 1.4;       /* Line height for readability */
    }

    .optionslist li strong {
      font-weight: bold;      /* Emphasize the key phrase */
      color: #333;            /* Text color (adjust as needed) */
    }

    .cross-button .btn{
      border: 2px solid black;
    border-radius: 50%;
    display: flex
;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    }

    .btn-disabled{
      background:#898989;
      border-color:#898989 !important;
      position:relative;
      cursor:not-allowed;
    }

    .btn-lower-text{
      position: absolute;
      bottom: -25px;
      font-size: 12px;
      font-style: italic;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      color: black;
      font-weight: 500; 
      font-size: 14px;
    }
  `]
})
export class SkipPasPopupComponent {
  constructor(public dialogRef: MatDialogRef<SkipPasPopupComponent>) {}

  onSelect(option: 'full' | 'skip' | 'pas'): void {
    this.dialogRef.close(option);
  }
}
